import { RootState } from 'editor/src/store/index';
import { PluginName } from 'editor/src/store/plugins/types';

const getPlugin = (state: RootState, pluginName: PluginName | string) =>
  state.plugins.list.find((element) => element.name === pluginName);

export default getPlugin;
